import React from 'react'

const Footer = () => {
  return (
    <footer>
      Made with love by <a href="http://gopperman.com/" target="_blank" rel="noopener noreferrer">@gopperman</a>
    </footer>
  )
}

export default Footer;
